var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurchases({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_23_1864)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.1319 22.3376H10.8306C9.02187 22.3376 7.47125 21.0469 7.14313 19.2681L4.19812 3.5622C4.07062 2.99656 3.56 2.58718 2.97875 2.58718H1.25C0.559375 2.58718 0 2.02779 0 1.33715C0 0.646514 0.559375 0.0871277 1.25 0.0871277H2.97875C4.735 0.0871277 6.2775 1.33403 6.64563 3.05156C6.64813 3.06219 6.65 3.07281 6.65188 3.08281L6.98063 4.83722H30.7494C31.5187 4.83722 32.11 5.52848 31.9825 6.29287L29.8306 19.2038C29.5281 21.0194 27.9725 22.3376 26.1319 22.3376ZM7.44938 7.33727L9.60063 18.8106C9.71062 19.4069 10.2275 19.8375 10.8306 19.8375H26.1319C26.7456 19.8375 27.2638 19.3981 27.365 18.7931L29.2744 7.33727H7.44938Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.6816 16.3141L10.7579 11.314C10.4572 9.68898 12.9154 9.23209 13.216 10.8596L14.1397 15.8597C14.4404 17.4854 11.9822 17.9429 11.6816 16.3141Z",
    fill: "var(--menu-icon-accent, #8fb4ff)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M22.7812 15.8818L23.615 10.8817C23.8869 9.25168 26.3531 9.66044 26.0806 11.293L25.2469 16.2931C24.97 17.9525 22.5112 17.5012 22.7812 15.8818Z",
    fill: "var(--menu-icon-accent, #8fb4ff)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11 32.0871C8.9325 32.0871 7.25 30.4046 7.25 28.3371C7.25 26.2695 8.9325 24.587 11 24.587C13.0675 24.587 14.75 26.2695 14.75 28.3371C14.75 30.4046 13.0675 32.0871 11 32.0871Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M26 32.0871C23.9325 32.0871 22.25 30.4046 22.25 28.3371C22.25 26.2695 23.9325 24.587 26 24.587C28.0675 24.587 29.75 26.2695 29.75 28.3371C29.75 30.4046 28.0675 32.0871 26 32.0871Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M17.25 16.0874V11.0873C17.25 9.43481 19.75 9.43231 19.75 11.0873V16.0874C19.75 17.74 17.25 17.7425 17.25 16.0874Z",
    fill: "var(--menu-icon-accent, #8fb4ff)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_1864"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0871277)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchases);
export default __webpack_public_path__ + "static/media/Purchases.2f04907351df908b9d4722ba594074e1.svg";
export { ForwardRef as ReactComponent };